<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{ retornarTitulo()}}</p>
        </header>
       
        <section class="modal-card-body is-paddingless" style="overflow-x: hidden;">              
            <div class="panel">                

                <p class="panel-block">
                    <searchIdName  :id.sync="clienteCodigoExterno" :codigoExterno="true"
                    :trazDesativado="false" :label="$t('SISTEMA.CLIENTE')" table="Cliente" :camposAdicionais="'&unidadeId='+unidadeId" :leitura="true">
                    </searchIdName>                                         
                                               
                </p>      

                <div  v-if="id>0" class="panel-block">  
                    <b-field expanded :label="$t('GUIAATENDIMENTO.CONTRATO')">
                        <b-input :disabled="true" type="number"  v-model="CodigoContrato"></b-input>
                        <b-button icon-left="square-edit-outline" @click="atualizarContrato(id)"
                                :title="$t('GUIAATENDIMENTO.ATUALIZARCONTRATO')"></b-button>                        
                    </b-field>                                    
                </div>


                <p class="panel-block">
                    <b-field :label="$t('MODALCADASTROOCORRENCIAS.TIPO')">
                    </b-field>
                </p>
                <div class="panel-block">                                         
                    <b-select expanded v-model="Tipo"   >                        
                        <template v-for="(item, index) in listaTiposOcorrencias">
                            <option v-bind:key="index" :value="item.valor">
                                {{item.descricao}}
                            </option>
                        </template>
                    </b-select>                                                                                                                      
                </div>   
                

                <div v-if="id>0  && DataHoraAprovacaoFinanceiro !=null && DataHoraEmissao ==null" class="panel-block">                                         
                    <searchIdName   expanded :id.sync="funcionarioEmissorId" :trazDesativado="false" 
                    :label="$t('MODALCADASTROOCORRENCIAS.RESPONSAVELEMISSOR')" table="FuncionariosUnidade" :camposAdicionais="'&unidadeId='+unidadeId">
                    </searchIdName>                                                                                                                      
                </div>                 
                <p class="panel-block">
                    <b-field :label="$t('MODALCADASTROOCORRENCIAS.DESCRICAO')">
                    </b-field>
                </p>
                <div class="panel-block">
                    <textarea class="textarea" v-model="observacao" rows="3"></textarea>                                      
                </div>  

                
                <p  v-if="id>0 && DataHoraInstalacaoFutura!=null && DataHoraEntrega==null && DataHoraConcluido==null && DataHoraCancelado==null" class="panel-block">
                    <b-field :label="$t('MODALCADASTROOCORRENCIAS.AGENDARENTREGA')">
                    </b-field>
                </p>
                <div  v-if="id>0 && DataHoraInstalacaoFutura!=null && DataHoraEntrega==null && DataHoraConcluido==null && DataHoraCancelado==null" class="panel-block">                                         
                    <b-input v-model="DataHoraAgendamentoEntrega" readonly disabled></b-input>                                                                                                               
                </div> 
                
                <p  v-if="id>0 && DataHoraEntrega!=null && DataHoraInstalacao==null && DataHoraConcluido==null && DataHoraCancelado==null" class="panel-block">
                    <b-field :label="$t('MODALCADASTROOCORRENCIAS.AGENDARINSTALACAO')">
                    </b-field>
                </p>
                <div  v-if="id>0 && DataHoraEntrega!=null && DataHoraInstalacao==null && DataHoraConcluido==null && DataHoraCancelado==null" class="panel-block">                                         
                    <b-input v-model="DataHoraAgendamentoInstalacao" readonly disabled></b-input>                                                                                                               
                </div>    
                
                <div  v-if="id>0  && DataHoraEmissao !=null"  class="panel-block">
                    <div class="columns">
                        <div class="column">
                            <b-field v-if="id>0 " :label="$t('GUIAATENDIMENTO.LETRA')">
                            </b-field>
                                <b-input maxlength="150"  type="text" v-model="letra" :disabled="true"></b-input>                                           
                        </div>   
                        <div class="column">
                            <b-field v-if="id>0 " :label="$t('GUIAATENDIMENTO.ELIST')">
                            </b-field>                        
                            <b-input maxlength="150"  type="text" v-model="eList" :disabled="true"></b-input>                                           
                        </div>              
                        <div class="column">
                            <b-field v-if="id>0" :label="$t('GUIAATENDIMENTO.VALOR')">
                            </b-field>
                            <b-input maxlength="150"  type="text" :value="valorFormatado" :disabled="true"></b-input>
                        </div>
                        <div class="column">
                            <b-button v-if="id>0 && DataHoraEmissao!=null" icon-left="home-edit" size="is-small" class="is-info ml-2"
                                            @click="atualizarListarAmbientes(true,false)"                                       
                                            title="Selecionar e atualizar ambientes do EList"></b-button>                                                    
                        </div>                         
                    </div>  
                </div>                  

                <div class="panel-block">                    
                                  
                    <span v-if=" DataHoraConcluido!=null">                                    
                        <b-notification  type="is-success" has-icon icon-size="is-medium" :closable="false" role="alert" >
                            {{$t('MODALCADASTROOCORRENCIAS.CONCLUIDO').toUpperCase()}}
                        </b-notification>                                          
                    </span>  
                    <span v-if=" DataHoraCancelado!=null">                                    
                        <b-notification  type="is-danger" has-icon icon-size="is-medium" :closable="false" role="alert" >
                            {{$t('MODALCADASTROOCORRENCIAS.OCORRENCIAEXCLUIDA').toUpperCase()}}
                        </b-notification>                                          
                    </span>    
                    <b-field  v-if="id>0 && DataHoraAprovacaoFabrica==null && DataHoraConcluido==null && DataHoraCancelado==null">
 
                        <b-switch v-if="DataHoraDevolucao==null" v-model="devolucaoPendencia" @input="devolucaoSupervisor()"  type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.DEVOLVER')}}
                        </b-switch> 
                        <b-switch v-if="DataHoraDevolucao!=null" v-model="resolverPendenciaOcorrencia" @input="resolverPendencia()"  type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.DEVOLVERRESOLVIDO')}}
                        </b-switch>                                                                                            
                    </b-field>  
                    <b-field  v-if="id>0 && DataHoraAprovacaoFabrica!=null && DataHoraAprovacaoOrcamento==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch v-model="aprovacaoOrcamento" @input="confirmarAprovarOrcamento()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.APROVACAOORCAMENTO')}}
                        </b-switch>                                                                    
                    </b-field>
                    <b-field  v-if="id>0 && DataHoraAprovacaoFabrica!=null && DataHoraAprovacaoOrcamento!=null && DataHoraOrcamento==null   && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch v-model="efetivacaoOrcamento" @input="listarContratos()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.ORCAMENTOEFETIVADA')}}
                        </b-switch>      
                        <b-switch v-model="canceladoOrcamento" @input="confirmarCancelarOrcamento()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.ORCAMENTOCANCELADA')}}
                        </b-switch>                                                                                      
                    </b-field>                    
                    <b-field  v-if="id>0 && DataHoraOrcamento!=null && DataHoraAprovacaoFinanceiro==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch v-model="aprovacaoFinanceiro" @input="confirmarAprovarFinanceiro()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.APROVACAOFINANCEIRO')}}
                        </b-switch>                                                                    
                    </b-field>  
                    <b-field  v-if="id>0 && DataHoraAprovacaoFinanceiro!=null && DataHoraEmissao==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch v-if="DataHoraDevolucao==null" v-model="emissaoRealizada" @input="atualizarListarAmbientes(true,false)"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.EMISSAOREALIZADA')}}
                        </b-switch>
                        <b-switch v-if="DataHoraDevolucao==null" v-model="devolucaoPendencia" @input="devolucaoSupervisor()"  type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.DEVOLVER')}}
                        </b-switch> 
                        <b-switch v-if="DataHoraDevolucao!=null" v-model="resolverPendenciaOcorrencia" @input="resolverPendencia()"  type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.DEVOLVERRESOLVIDO')}}
                        </b-switch>                                                                                                                      
                    </b-field>        
                    <b-field  v-if="id>0 && DataHoraEmissao!=null && DataHoraEnvioFabrica==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch v-model="aprovacaoEnvioFabrica" @input="confirmarEnvioFabrica()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.ENVIOAPROVACAOFABRICA')}}
                        </b-switch>                                                                    
                    </b-field>                                      
                    <b-field  v-if="id>0 && DataHoraEnvioFabrica!=null && DataHoraFinalizarEfinance==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch v-model="finalizarEfinance" @input="confirmarFinalizarEfinance()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.FINALIZAREFINANCE')}}
                        </b-switch>                                                                    
                    </b-field> 

                    <b-field  v-if="id>0 && DataHoraFinalizarEfinance!=null && DataHoraInstalacaoFutura==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch v-model="liberarEntrega" @input="confirmarLiberarEntrega()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.LIBERARENTREGA')}}
                        </b-switch>                                                                    
                    </b-field>                     
   
                    <b-field  v-if="id>0 && DataHoraInstalacaoFutura!=null && DataHoraEntrega==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch  v-model="agendarEntrega" @input="confirmarAgendamentoEntrega()" type="is-success">
                              {{$t('MODALCADASTROOCORRENCIAS.AGENDARENTREGA')}}
                        </b-switch>                         
                        <b-switch v-model="aprovacaoEntrega" @input="confirmarEntrega()"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.CONCLUIRENTREGA')}}
                        </b-switch>                                                                    
                    </b-field> 
                                   
                    <b-field  v-if="id>0 && DataHoraEntrega!=null && DataHoraInstalacao==null && DataHoraConcluido==null && DataHoraCancelado==null">
                        <b-switch  v-model="agendarInstalacao" @input="confirmarAgendamentoEntrega()" type="is-success">
                              {{$t('MODALCADASTROOCORRENCIAS.AGENDARINSTALACAO')}}
                        </b-switch>                         
                        <b-switch v-model="finalizarInstalacaoComAssinatura" @input="concluirInstalacao(true)"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.CONCLUIRINSTALACAOCOMASSINATURA')}}
                        </b-switch>
                        <b-switch v-model="finalizarInstalacaoSemAssinatura" @input="concluirInstalacao(false)"   type="is-success">
                            {{$t('MODALCADASTROOCORRENCIAS.CONCLUIRINSTALACAOSEMASSINATURA')}}
                        </b-switch>                                                                   
                    </b-field>                                                                                                                                                                                                                                      
                </div> 
                <br>
                <br>
                <br>
                <div class="columns" >                    
                  
                        <div class="column is-4 " style="margin: 5px" >
                            <div v-if="files" class="tags">
                                <span v-for="(file, index) in files"
                                    :key="index" class="tag is-primary" >
                                    {{file.name}}
                                    <button class="delete is-small" type="button" @click="deleteFile(index)">
                                    </button>
                                </span>                                            
                            </div>                              
                            <b-field>
                                <b-upload  
                                accept=".pdf,.jpg,.jpeg,.png,.mp4,.mov,.wmv,.PNG,.PDF,.JPG,.JPEG,.MP4,.MOV,.WMV"
                                multiple expanded drag-drop v-model="files" >
                                    <section class="section">
                                        <div class="content has-text-centered">
                                            <p>
                                                <b-icon icon="upload" size="is-medium"> </b-icon>
                                            </p>
                                            <p>{{$t('ANEXOS.ARRASTEARQUIVOS')}}</p>
                                            <p>({{$t('ANEXOS.APENASFOTOS')}})</p>
                                        </div>
                                    </section>
                                </b-upload>                                          
                            </b-field>
                            <table class="table is-striped">
                                <tbody>
                                    <tr v-for="(anexo, index) in anexos" :key="index">
                                        <td width="50%">                                        
                                            <p>
                                                <a @click="visualizarAnexo(anexo.id, anexo.fileName)" class="is-size-7 text-nowrap"><b>{{ anexo.fileName }}</b></a>
                                            </p>
                                        </td>

                                        <td width="50%">                                        
                                            <p>
                                                {{ anexo.tipoAnexoNome }}
                                            </p>
                                        </td>                                        
                                        
                                        <td v-if="anexo.id ">                                           
                                            <b-button icon-left="delete"
                                                    type="is-danger"
                                                    size="is-small"
                                                    :title="$t('ANEXOS.REMOVERANEXO')"
                                                    @click="removerAnexo(anexo.id)"></b-button>
                                        </td>
                                    </tr>
                                    <tr v-if="uploadingAnexo">
                                        <td colspan="2">
                                            <b-progress type="is-info" :value="uploadingAnexo" show-value></b-progress>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>                            
                                        
                        </div> 
                        
                        <div class="column is-5"  style="margin: 5px">  
                      
                            <div >  
                                <b-field  class="wrap-mobile" :label="$t('SISTEMA.OBSERVACAO')" >
                                    <b-input expanded v-model="observacoes" type="text" ></b-input> 
                                    <b-button type="is-success"  icon-left="plus" @click="incluirObservacao()"> {{$t('SISTEMA.INCLUIR')}} </b-button>
                                </b-field>                                  
                            </div>                            

                            

                            <div v-if="id > 0">                      
                                <table class="table is-fullwidth">
                                    <tr v-for="(item, index) in historicoAlteracoes" :key="index">
                                        <td>
                                            <h4>
                                                {{ item.observacao }}                                         
                                            </h4>
                                        </td>
                                        <td>
                                            <span><b>{{ item.usuarioNome }}</b> ({{ item.usuarioId }})</span>
                                        </td>
                                        <td>
                                            <span>{{ item.dataHora | moment('DD/MM/YYYY HH:mm') }}</span>
                                        </td>
                                    </tr>
                                </table>                                    
                            </div>                               
                        </div>
                                                                                                                                                                                                                                                                                                                                                                           
                </div>                                    
                                         
            </div>
        </section>
        <footer class="modal-card-foot">

            <b-button  type="is-success"
                    :loading="salvandoDados"
                    @click="confirmar">{{$t('SISTEMA.CONFIRMAR')}}</b-button>                
                    
                    
                      
            <b-button @click="$emit('close'); $emit('carregarAstecs'); $emit('loadAnexos');  $emit('loadHistoricoAlteracoes');">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState,mapGetters } from 'vuex'        
    import searchIdName from '@/components/searchIdName.vue'  
    import modalAprovarOcorrenciasAstecCustoFabrica from '@/components/astecs/modalAprovarOcorrenciasAstecCustoFabrica.vue'
    import modalCancelarOcorrenciasAstec from '@/components/astecs/modalCancelarOcorrenciasAstec.vue'   
    import modalFinalizarInstalacaoAstec from '@/components/astecs/modalFinalizarInstalacaoAstec.vue'   
    import modalListarContratos from '@/components/venda/modalListarContratos.vue' 
    import modalListarAmbientes from '@/components/atendimento/modalListarAmbientes.vue' 
    

    export default {
        props: {
            id: Number,
            astecId: Number,                                                               
            clienteCodigoExterno: Number,
            
        },
        data() {
            return {                   
                observacao: null,                                
                salvandoDados :false,                
                files:[],
                anexos:[],
                uploadingAnexo: null,
                DataHoraCancelado:null,
                DataHoraConcluido:null,
                DataHoraAgendamento: null,
                DataHoraAgendamentoEntrega:null,
                DataHoraAgendamentoInstalacao:null,
                DataHoraAprovacaoFabrica: null,
                DataHoraAprovacaoOrcamento: null,
                DataHoraOrcamento: null,
                CodigoContrato: 0,
                DataHoraAprovacaoFinanceiro: null,
                DataHoraEmissao: null,
                DataHoraEnvioFabrica: null,
                DataHoraFinalizarEfinance: null,
                DataHoraInstalacaoFutura: null,
                DataHoraEntrega: null,
                DataHoraInstalacao: null,  
                DataHoraDevolucao:null,                       
                TipoNome: null,                
                Tipo: null,
                historicoAlteracoes:[],
                observacoes:null,  
                listaTiposOcorrencias: [],
                aprovacaoFabrica:false,    
                aprovacaoOrcamento:false, 
                canceladoOrcamento:false,
                efetivacaoOrcamento:false,
                aprovacaoEntrega:false,
                aprovacaoFinanceiro:false,
                emissaoRealizada:false,
                finalizarEfinance:false,
                liberarEntrega:false,
                aprovacaoEnvioFabrica:false,
                finalizarInstalacaoComAssinatura:false,
                finalizarInstalacaoSemAssinatura:false,
                agendarEntrega:false,
                agendarInstalacao:false,
                funcionarioEmissorId:null,
                guia:null,
                eList:null,                
                letra:null,
                valor: null,   
                devolucaoPendencia:false,
                resolverPendenciaOcorrencia:false,               
            }
        },
        components: {     
            searchIdName                
            
        },        
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),  
            ...mapGetters([
                'isInRole'
            ]),    
            valorFormatado() {
                if (!this.valor) return '';
                return this.valor.split(',').map(v => this.retornarValorFormatado(v)).join(', ');
            }                      
        },        

        mounted() {
            this.loadTiposOcorrencia();  
            this.loadData();
            this.loadHistoricoAlteracoes();                        
        },
        methods: {

                        
            confirmarAgendamentoEntrega(){

                this.isLoading = true;    
                this.$http.get('/api/astecs/edit?id=' + this.astecId)
                    .then(res => {                            
                        this.guia = res.data;
                        this.guia.dataHoraCadastroStr = this.$moment(res.data.dataHoraCadastro).format("DD/MM/YYYY HH:mm");      
                        this.guia.observacoes = null;                                                  

                    }).finally(() => {
                        this.isLoading = false;    
                        this.$emit('close');
                        this.guia.tipoAgenda = 5;
                        this.$router.push({ name: 'agenda',query:{tipo: 5,filtrarTodos: true},params: { guia: this.guia,voltarTela:'astecs'}  });                          
                    });                
                                                                                    

            },         
            
            removerfinalizacaoInstalacao(){
                this.finalizarInstalacaoComAssinatura = false;
                this.finalizarInstalacaoSemAssinatura = false;
            },
            concluirInstalacao(comAssinatura){
                    this.$buefy.modal.open({
                        parent: this,
                        component: modalFinalizarInstalacaoAstec,
                        props: {
                            id: this.id,
                            astecId: this.astecId,                            
                            comAssinatura: comAssinatura                        
                        },
                        events: {
                            closeModalOcorrencia: this.closeModalOcorrencia,
                            removerfinalizacaoInstalacao: this.removerfinalizacaoInstalacao
                        },
                        hasModalCard: true,
                        trapFocus: true
                    })                  
            },               

                
            confirmarEntrega(){
                this.$buefy.dialog.confirm({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMACONCLUIRENTREGA'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        

                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`);                         
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/ConfirmarEntregaOcorrencia?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')                            
                                        this.$emit('close');  
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }                        
                        
                        
                    },
                    onCancel: () => {                        
                        this.aprovacaoEntrega = false;
                    },
                });       
            },           
            confirmarLiberarEntrega(){

                if(!this.faturado){
                    this.$buefy.dialog.alert({
                        title: this.$t('SISTEMA.ATENCAO'),
                        message: this.$t('GUIAATENDIMENTO.MENSAGEMFATURADO'),
                        type: 'is-info',
                        hasIcon: true
                    });
                   
                    setTimeout(() => { this.liberarEntrega = false;},500);
                    return true;
                }                      

                this.$buefy.dialog.confirm({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMALIBERARENTREGA'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        

                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`);                         
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/LiberarEntrega?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')                            
                                        this.$emit('close');  
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }                        
                        
                        
                    },
                    onCancel: () => {                        
                        this.liberarEntrega = false;
                    },
                });                 

            },
            confirmarFinalizarEfinance(){
                this.$buefy.dialog.confirm({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMAFINALIZAREFINANCE'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        

                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`);                         
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/ConfirmarFinalizacaoEfinance?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')                            
                                        this.$emit('close');  
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }                        
                        
                        
                    },
                    onCancel: () => {                        
                        this.finalizarEfinance = false;
                    },
                });                   

            },
            confirmarEnvioFabrica(){
                this.$buefy.dialog.confirm({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMAAPROVACAOFABRICAFIN'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        

                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`);                         
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/ConfirmarEnvioFabricaOcorrencia?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')                            
                                        this.$emit('close');  
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }                        
                        
                        
                    },
                    onCancel: () => {                        
                        this.aprovacaoEnvioFabrica = false;
                    },
                });       
            },


            removerConcluirAssistencia(){
                this.emissaoRealizada=false;
            },
            preencherElist(ambientesSelecionados){                
                this.eList = ambientesSelecionados.map(x => x.elist).join(',');
                this.letra = ambientesSelecionados.map(x => x.opcao).join(',');
                this.valor = ambientesSelecionados.map(x => x.valor).join(',');

                setTimeout(() => {                                        
                    if(this.emissaoRealizada){
                        this.DataHoraEmissao = new Date();
                        this.confirmar();                        
                    }

                },500);

            },

            
            resolverPendencia(){

                this.$buefy.dialog.confirm({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMDEVOLVERRESOLVIDO'),                 
                    confirmText: 'Confirmar',
                    cancelText: 'Cancelar',
                    trapFocus: true,
                    onConfirm: (r) => {
                        
                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`); 
                        params.push(`observacoes=${r}`); 
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/ResolverPendencia?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')       
                                        this.$emit('close');
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }

                    },
                    onCancel:() =>{
                        this.resolverPendenciaOcorrencia=false;
                    }
                });    


            },                  
                             
            devolucaoSupervisor(){

                this.$buefy.dialog.prompt({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMDEVOLVER'),                 
                    inputAttrs: {
                        type: 'text',                        
                        placeholder: 'Descrever Motivo',
                        value:null
                    }, 
                    confirmText: 'Confirmar',
                    cancelText: 'Cancelar',
                    trapFocus: true,
                    onConfirm: (r) => {
                        
                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`); 
                        params.push(`observacoes=${r}`); 
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/DevolucaoPendencia?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')       
                                        this.$emit('close');
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }

                    },
                    onCancel:() =>{
                        this.devolucaoPendencia=false;
                    }
                });    


            },  

            async atualizarListarAmbientes(trazerApenasNaoEnviados,apenasEmAbertos){
                

                this.$buefy.modal.open({
                    parent: this,
                    component: modalListarAmbientes,
                    props: {
                        guia: { id: 0, clienteCodigoExterno: this.clienteCodigoExterno  },
                        assistencia: trazerApenasNaoEnviados,
                        apenasEmAbertos:apenasEmAbertos                      
                    },                   
                    events: {
                        preencherElist: this.preencherElist,  
                        removerConcluirAssistencia: this.removerConcluirAssistencia                      
                    },                     
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen: true
                })

            },            

            confirmarAprovarFinanceiro(){

                this.$buefy.dialog.confirm({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMAPROVACAOFINANCEIRO'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        

                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`);                         
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/ConfirmarAprovacaoFinanceiroOcorrencia?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')                            
                                        this.$emit('close');  
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }                        
                        
                        
                    },
                    onCancel: () => {                        
                        this.aprovacaoFinanceiro = false;
                    },
                });                   


            },                      
            confirmarAprovarOrcamento(){

                this.$buefy.dialog.confirm({
                    message: this.$t('MODALCADASTROOCORRENCIAS.MENSAGEMAPROVACAOORCAMENTO'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        

                        this.salvandoDados=true;    
                        const params = [];                    
                        params.push(`id=${this.id}`);                         
                                                                                                        
                        try {
                            this.$http.get(`/api/astecs/ConfirmarAprovacaoOrcamentoOcorrencia?${params.join('&')}`)
                                    .then(res => res.data)
                                    .then(data => {
                                        return true;
                                    }).finally(() => {    
                                        this.salvandoDados=false; 
                                        this.$emit('carregarAstecs')                            
                                        this.$emit('close');  
                                    });                              
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }                        
                        
                        
                    },
                    onCancel: () => {                        
                        this.aprovacaoOrcamento = false;
                    },
                });                   


            },                  
                               
            closeModalOcorrencia(){
                this.$emit('carregarAstecs')                                                        
                this.$emit('close');  
            },
            removerAprovarAnaliseFabrica (){
                this.aprovacaoFabrica = false;                
            },                   
            confirmarAprovarAnaliseFabrica(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalAprovarOcorrenciasAstecCustoFabrica,
                    props: {
                        id: this.id,                        
                    },                    
                    events: {                        
                        removerAprovarAnaliseFabrica: this.removerAprovarAnaliseFabrica,
                        closeModalOcorrencia: this.closeModalOcorrencia
                    },                                                           
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:false
                })
            },  

            atualizarContrato(ocorrenciaId){
                this.$buefy.dialog.prompt({
                    title: this.$t('GUIAATENDIMENTO.ATUALIZARCONTRATO'),                    
                    inputAttrs: {
                        type: 'number',                        
                        placeholder: 'Código do Contrato',
                        value: null
                    }, 
                    confirmText: 'Confirmar',
                    cancelText: 'Cancelar',
                    trapFocus: true,
                    onConfirm: (res) => {
                        this.$http.get(`/api/astecs/AtualizarContrato?codigoContrato=${res}&ocorrenciaId=${ocorrenciaId}`)
                        .then((r) => {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t("SISTEMA.SALVOSUCESSO"),
                                type: 'is-success'
                            });
                            this.loadData();
                            this.loadHistoricoAlteracoes();   
                        }, error => {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Não foi possível salvar ",
                                type: 'is-danger'
                            });
                            
                        }
                    )}
                });                
                return true;
            },


            preencherDadosContrato(contrato){
                this.CodigoContrato = contrato.codigoContrato;         
                this.DataHoraOrcamento = new Date();    
                this.confirmar();   
            },
            listarContratos(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalListarContratos,
                    props: {
                        guiaId: 0,
                        clienteCodigoExterno: this.clienteCodigoExterno,
                        vendaDireta: false                                      
                    },                   
                    events: {
                        preencherDadosContrato: this.preencherDadosContrato                        
                    },                     
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen: true
                })
            },  
          
            removerCancelarOrcamento (){
                this.canceladoOrcamento = false;                
            },                   
            confirmarCancelarOrcamento(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCancelarOcorrenciasAstec,
                    props: {
                        id: this.id,                        
                    },                    
                    events: {                        
                        removerCancelarOrcamento: this.removerCancelarOrcamento,
                        closeModalOcorrencia: this.closeModalOcorrencia
                    },                                                           
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:false
                })
            },                            
            loadTiposOcorrencia(){
                this.$http.get('/api/search/TipoOcorrencia')
                .then(res => {
                    if (res.data != null) {
                        this.listaTiposOcorrencias = res.data
                    }                    
                });
                
            },               
            deleteFile(index){                
                this.files.splice(index, 1)            
            },            

            retornarTitulo(){

                if(this.id > 0){
                    return this.$t('MODALCADASTROOCORRENCIAS.ALTERACAOOCORRENCIA') ;
                }else{
                    return this.$t('MODALCADASTROOCORRENCIAS.CADASTROOCORRENCIA');
                }

            },          
            loadData(){
                setTimeout(() => {

                    if(this.clienteCodigoExterno > 0)                
                        this.clienteCodigoExternoSelecionado = this.clienteCodigoExterno; this.apenasLeitura=true;

                    if(this.id){
                        this.$http.get('/api/astecs/retornarAstecOcorrencia?id=' + this.id)
                        .then(res => res.data)
                        .then(data => {                            
                            this.eList = data.eList; 
                            this.letra = data.letra;                            
                            this.valor = data.valor;          
                            this.faturado = data.faturado;      
                            this.funcionarioEmissorId = data.funcionarioEmissorId;                                 
                            this.observacao = data.observacao;                                   
                            this.DataHoraAprovacaoFabrica =  (data.dataHoraAprovacaoFabrica) ?  this.$moment(data.dataHoraAprovacaoFabrica).toDate() : null ;
                            this.DataHoraAprovacaoOrcamento =  (data.dataHoraAprovacaoOrcamento) ?  this.$moment(data.dataHoraAprovacaoOrcamento).toDate() : null ;
                            this.DataHoraOrcamento =  (data.dataHoraOrcamento) ?  this.$moment(data.dataHoraOrcamento).toDate() : null ;
                            this.CodigoContrato = data.codigoContrato;
                            this.DataHoraAprovacaoFinanceiro =  (data.dataHoraAprovacaoFinanceiro) ?  this.$moment(data.dataHoraAprovacaoFinanceiro).toDate() : null ;
                            this.DataHoraEmissao = (data.dataHoraEmissao) ?  this.$moment(data.dataHoraEmissao).toDate() : null ;
                            this.DataHoraEnvioFabrica =  (data.dataHoraEnvioFabrica) ?  this.$moment(data.dataHoraEnvioFabrica).toDate() : null ;                        
                            this.DataHoraFinalizarEfinance = (data.dataHoraFinalizarEfinance) ?  this.$moment(data.dataHoraFinalizarEfinance).toDate() : null ;
                            this.DataHoraInstalacaoFutura = (data.dataHoraInstalacaoFutura) ?  this.$moment(data.dataHoraInstalacaoFutura).toDate() : null ;                            
                            this.DataHoraEntrega =  (data.dataHoraEntrega) ?  this.$moment(data.dataHoraEntrega).toDate() : null ;                        
                            this.DataHoraCancelado =  (data.dataHoraCancelado) ?  this.$moment(data.dataHoraCancelado).toDate() : null ; 
                            this.DataHoraConcluido =  (data.dataHoraConcluido) ?  this.$moment(data.dataHoraConcluido).toDate() : null ; 
                            this.DataHoraPrazo =  (data.dataHoraPrazo) ?  this.$moment(data.dataHoraPrazo).toDate() : null ;                         
                            this.DataHoraInstalacao =  (data.dataHoraInstalacao) ?  this.$moment(data.dataHoraInstalacao).toDate() : null ;                                                                        
                            this.DataHoraAgendamento =  (data.dataHoraAgendamento) ?  this.$moment(data.dataHoraAgendamento).toDate() : null;
                            this.DataHoraDevolucao =  (data.dataHoraDevolucao) ?  this.$moment(data.dataHoraDevolucao).toDate() : null;                            
                            this.DataHoraAgendamentoEntrega =  (data.dataHoraAgendamentoEntrega) ?  this.$moment(data.dataHoraAgendamentoEntrega).format("DD/MM/YYYY HH:mm") : null; 
                            this.DataHoraAgendamentoInstalacao =  (data.dataHoraAgendamentoInstalacao) ?  this.$moment(data.dataHoraAgendamentoInstalacao).format("DD/MM/YYYY HH:mm") : null;                             
                            this.TipoNome = data.tipoNome;                                                                                    
                            this.Tipo = data.tipo;                                                                                    
                        }).finally(() => {                                
                            this.loadAnexos();
                                                                                                             
                        }); 
                        
                                         
                    }
                    
                },500);
            },
            loadHistoricoAlteracoes() {
                this.$http.get('/api/astecs/OcorrenciaAstecObservacoes?id=' + this.id)
                    .then(res => {
                        this.historicoAlteracoes = res.data
                    })
            },  

            async incluirObservacao(){

                this.salvandoDados=true;
                

                if (this.observacoes== null  || this.observacoes == '' || this.observacoes == undefined) {
                    this.salvandoDados = false;
                    return;
                }      
                
                const assistenciaObservacao = {
                    guiaId: this.id,
                    observacao : this.observacoes
                }                
                this.isLoading = true;  
                
                try {
                    this.$http.post('/api/astecs/OcorrenciaAstecObservacoes', assistenciaObservacao)
                        .then(res => {
                            this.salvandoDados=false;
                            return true;

                        }).finally(() => {                                
                            this.salvandoDados=false;    
                            this.observacoes = null;

                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t('GUIAATENDIMENTO.MENSAGEMOBSERVACAOSALVA'),
                                type: 'is-success'
                            }); 
                            
                            this.loadHistoricoAlteracoes();
                                                                                                             
                        }); 
                        
                    } catch (e) {
                        this.salvandoDados=false;                        
                        console.error(e);
                    }                    
            },   

           
            visualizarAnexo(anexoId, fileName) {                
                window.open('/api/astecs/anexoPdf?id=' + this.astecId + '&anexoId=' + anexoId + '&fileName=' + fileName);
            },
            loadAnexos() {
                this.uploadingAnexo = null
                this.anexos = null
                this.$http.get('/api/astecs/anexos?id=' + this.astecId)
                    .then(res => {
                        if(res.data){
                            this.anexos = res.data                                        
                        }

                    })
            },  
            removerAnexo(id) {
                const anexo = this.anexos.filter(x => x.id == id)[0]
                this.$buefy.dialog.confirm({
                    title: this.$t('ANEXOS.EXCLUIRANEXO'),
                    message: this.$t('ANEXOS.CONFIRMAEXCLUSAO') + anexo.fileName.replace(/^.*[\\/]/, '') + '</b> ?',
                    confirmText: this.$t('SISTEMA.CONFIRMAR'),                    
                    cancelText: this.$t('SISTEMA.CANCELAR'),                      
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {

                        const removerAnexo = {
                            tipo: "guia",
                            anexoId: id
                        }

                        this.isLoading = true;    
                        this.$http.post('/api/astecs/excluirAnexoGuia', removerAnexo)
                            .then((res) => {
                                if (res.body.erro) {
                                    this.$buefy.toast.open({
                                        duration: 5000,
                                        message: res.body.erro,
                                        type: 'is-danger'
                                    })
                                } else {
                                    this.loadAnexos()
                                }
                            }).finally(() => {                                
                                this.isLoading = false;    
                            });
                            
                    }
                })
            },                            

            incluirAnexo() {
                const formData = new FormData()
                formData.append('id', this.astecId);
                formData.append('tipoOcorrencia', this.Tipo);
                formData.append('type', 'guia');

                Array
                    .from(Array(this.files.length).keys())
                    .map(x => {                        
                        formData.append('anexo', this.files[x], this.files[x].name);
                    });

                this.uploadingAnexo = 0;
                this.isLoading = true;                    
                this.$http.post('/api/astecs/anexoGuia', formData, {
                    progress(e) {
                        if (e.lengthComputable) {
                            this.uploadingAnexo = (e.loaded / e.total * 100)
                        }
                    }
                }).then(response => {                    
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: response.data.sucesso,
                        type: 'is-success'
                    })                    
                    this.isLoading = false;  
                                     
                }, error => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error.message,
                        type: 'is-danger'
                    })
                }).finally(() => {                                
                    this.$emit('loadAnexos');
                    this.$emit('loadHistoricoAlteracoes');                                                                  
                });   
            },        
            async confirmar() {

                if(this.clienteCodigoExternoSelecionado>0 && this.observacao !=null ){  
                    this.salvandoDados=true;
                    const params = [];         
                    
                    if (this.id) params.push(`id=${this.id}`);                                                            
                    params.push(`astecId=${this.astecId}`);                                                                                                                                     
                    params.push(`clienteId=${this.clienteCodigoExternoSelecionado}`);     
                    params.push(`observacao=${this.observacao}`);      
                    params.push(`tipo=${this.Tipo}`);  
                    params.push(`codigoContrato=${this.CodigoContrato}`);                       
                    if(this.eList)  params.push(`eList=${this.eList}`);                    
                    if(this.letra)  params.push(`Letra=${this.letra}`);
                    if(this.valor) params.push(`valor=${this.valor}`);
                    if(this.funcionarioEmissorId) params.push(`funcionarioEmissorId=${this.funcionarioEmissorId}`);
                

                    if(this.DataHoraAprovacaoFabrica) params.push(`DataHoraAprovacaoFabrica=${this.$moment(this.DataHoraAprovacaoFabrica).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraAprovacaoOrcamento) params.push(`DataHoraAprovacaoOrcamento=${this.$moment(this.DataHoraAprovacaoOrcamento).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraOrcamento) params.push(`DataHoraOrcamento=${this.$moment(this.DataHoraOrcamento).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraAprovacaoFinanceiro) params.push(`DataHoraAprovacaoFinanceiro=${this.$moment(this.DataHoraAprovacaoFinanceiro).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraEmissao) params.push(`DataHoraEmissao=${this.$moment(this.DataHoraEmissao).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraEnvioFabrica) params.push(`DataHoraEnvioFabrica=${this.$moment(this.DataHoraEnvioFabrica).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraFinalizarEfinance) params.push(`DataHoraFinalizarEfinance=${this.$moment(this.DataHoraFinalizarEfinance).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraInstalacaoFutura) params.push(`DataHoraInstalacaoFutura=${this.$moment(this.DataHoraInstalacaoFutura).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraEntrega) params.push(`DataHoraEntrega=${this.$moment(this.DataHoraEntrega).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraInstalacao) params.push(`DataHoraInstalacao=${this.$moment(this.DataHoraInstalacao).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraCancelado) params.push(`DataHoraCancelado=${this.$moment(this.DataHoraCancelado).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    if(this.DataHoraAgendamento) params.push(`DataHoraAgendamento=${this.$moment(this.DataHoraAgendamento).format('YYYY-MM-DDTHH:mm:ss')}`);                                        
                    
                                                                                                            
                    try {                            
                        this.$http.get(`/api/astecs/incluirAstecOcorrencia?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {
                            this.salvandoDados=false;

                            if(this.files && this.files.length>0)
                                this.incluirAnexo(); 
                            
                        }).finally(() => {                                
                            this.isLoading = false;    
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t("SISTEMA.SALVOSUCESSO"),
                                type: 'is-success'
                            });                                                       
                            this.$emit('carregarAstecs')                                                        
                            this.$emit('close');                                                                
                        });                             
                        
                    } catch (e) {
                        this.salvandoDados=false;                        
                        console.error(e);
                    }
                }

            },
            retornarValorFormatado(valor){
                const valorParse = parseFloat(valor);
                return valorParse.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });
            },            
            

        }
    }
</script>